import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const MobileBox = styled.div<{isHybridEmbedded: boolean}>`
    position: fixed;
    z-index:15;
    bottom: ${props => props.isHybridEmbedded?  'calc(env(safe-area-inset-bottom) + 84px)' : '34px'};

    right: 3px;
    
    cursor: pointer;
    
    display: grid;
    grid-template-rows: 45px 30px;
    justify-items: center;   
`;

const PcBox = styled(MobileBox)`
    transform: scale(1.2);
    right: 20px;
`;

export const DailyDealContainerBox = styledByDevice(PcBox, MobileBox);
